import {
  Alert,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import {
  ModalAcceptButton,
  TopBarContainedBrandButton,
} from "../../../../constants/component.constants";
import { ResponsiveRow } from "../../../../constants/layout.constants";
import ModalContainerModule from "../../../modules/modalContainer";
import {
  formatCurrency,
  isArray,
  isEmptyArray,
  isNullUndefined,
  tryParseFloat,
} from "../../../../util/util";
import {
  addOrDeleteUnit,
  getEditUnitDetails,
  getUnitMeters,
  leaseUnitCharges,
} from "../../../../services/lease.service";
import { getUnitOptions } from "../../../../services/list.service";
import { useCallback, useEffect, useState } from "react";
import { Delete } from "@mui/icons-material";
import {
  issueInfoMessage,
  issueResponseMessage,
  issueWarnMessage,
} from "../../../../actions/message";
import { saveReadingBulk } from "../../../../services/meters.service";
import LeaseChargeItems from "../../../modules/populateLeaseChargeItems";

/**
 *
 * REQUIREMENTS PROPS
 *
 * handleLeaseChargeItemAdd
 * handleLeaseChargeClose
 *
 * chargeItemsTotal
 * innerTask
 * leaseChargesTableRows
 * saveEditUnit
 * selectedLease
 * saveLeaseCharges
 * selectedUnitId
 * showSelectUnit
 * swapUnitsTableRows
 * unitOptions
 *
 *
 *
 */
export default function LeaseUnitSwapModal(props) {
  const [innerTask, setInnerTask] = useState("");
  const [unitOptions, setUnitOptions] = useState([]);
  const [chargeItems, setChargeItems] = useState([]);
  const [swapUnitsTableRows, setSwapUnitsTableRows] = useState("");
  const [selectedUnitId, setSelectedUnitId] = useState("");
  const [showSelectUnit, setShowSelectUnit] = useState(false);
  const [noOfUnitsBeforeUpdate, setNoOfUnitsBeforeUpdate] = useState(0);
  const [meterReadings, setMeterReadings] = useState(0);
  const [prevUnits, setPrevUnits] = useState([]);
  const [units, setUnits] = useState([]);
  const [chargeUnitsOptions, setChargeUnitsOptions] = useState([]);
  const [deletedUnitMeterReadings, setDeletedUnitMeterReadings] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedLease, setSelectedLease] = useState(
    props?.selectedLease || null,
  );

  function saveLeaseCharges() {
    if (innerTask === "Lease Charges") {
      setIsSaving(true);
      let tmp = selectedLease;
      tmp.leaseChargeItems = tmp.leaseChargeItems.concat(chargeItems);
      tmp.unitIds.push(selectedUnitId);
      let prevUnitsTemp = prevUnits;
      let unitSelectedIndex = unitOptions.findIndex(
        (e) => e.value === selectedUnitId,
      );
      prevUnitsTemp.push(unitOptions[unitSelectedIndex]);
      let noOfUnits = noOfUnitsBeforeUpdate + 1;
      setSelectedLease(tmp);
      setPrevUnits(prevUnitsTemp);
      setNoOfUnitsBeforeUpdate(noOfUnits);
      let periodicCharge = 0;
      let balance = 0;
      chargeItems.forEach((current) => {
        let amount = parseFloat(current.amount);
        let code = current.chargeCode.code;
        if (
          code === "SECDP" ||
          code === "LFEE" ||
          code === "MISC" ||
          code === "UTIDP"
        ) {
          balance += amount;
        } else periodicCharge += amount;
      });
      getUnitMeters(selectedUnitId)
        .then((data) => {
          let unit = {
            balance: balance,
            id: unitOptions[unitSelectedIndex].value,
            name: unitOptions[unitSelectedIndex].label,
            periodicCharge: periodicCharge,
            tenant: units[0].tenant,
            meters: data,
          };
          let noOfReadingsPerMeter = [];
          if (data.length > 0) {
            noOfReadingsPerMeter = data.map((item) => item.readings.length);
          }
          let tmpReadings = meterReadings;
          tmpReadings.push(noOfReadingsPerMeter);
          let tmp = units;
          tmp.push(unit);
          setMeterReadings(tmpReadings);
          setUnits(tmp);
          issueInfoMessage("Unit added and you can now proceed.");
          populateUnitSwapItems();
          handleLeaseChargeClose();
        })
        .finally(() => {
          setIsSaving(false);
        });
    }
  }

  const handleUnitSwapClose = (reload = false) => {
    props.handleSwapLeaseUnitClose(reload);
    setNoOfUnitsBeforeUpdate(0);
    setMeterReadings(0);
    setUnits([]);
    setSelectedUnitId("");
    setInnerTask("");
    setShowSelectUnit(false);
  };

  const handleLeaseChargeClose = () => {
    setInnerTask("Lease Units");
    setShowSelectUnit(false);
    setSelectedUnitId("");
    setChargeUnitsOptions([]);
    setChargeItems([]);
  };

  const loadModalData = useCallback(() => {
    getUnitOptions(selectedLease.facilityId).then((unitOptions) => {
      setUnitOptions(unitOptions);
    });
    getEditUnitDetails(selectedLease.id).then((data) => {
      if (isArray(data) && !isEmptyArray(data)) {
        let noOfReadings = data.map((e) =>
          e.meters.length === 0 ? null : e.meters.map((e) => e.readings.length),
        );
        data = data.map((item) => {
          if (item.meters) {
            item.meters = item.meters.map((meter) => {
              meter.newMeterReading = null;
              return meter;
            });
          }
          return item;
        });
        setNoOfUnitsBeforeUpdate(data.length);
        setMeterReadings(noOfReadings);
        setUnits(data);
        setInnerTask("Lease Units");
      }
    });
  }, [selectedLease.id, selectedLease.facilityId]);

  function handleSwapUnitChange(event) {
    let value = event.target.value;
    setSelectedUnitId(value);
    let obj = selectedLease;
    obj.unitIds.push(value);
    let unitIds = [];
    unitIds.push(value);
    setSelectedLease(obj);
    let currentItems = [];
    let options = [];
    for (let unit of unitOptions) {
      if (unit.value === value) {
        options.push(unit);
      }
    }
    setChargeUnitsOptions([
      ...new Map(options.map((v) => [v.value, v])).values(),
    ]);
    leaseUnitCharges(unitIds).then((response) => {
      for (let item of response) {
        currentItems.push({
          unit: { id: item.id, name: "" },
          amount: item.rent,
          chargeCode: { code: item.code, name: "" },
          taxable: false,
          effectiveDate: new Date(),
          note: "",
        });
      }
      setInnerTask("Lease Charges");
      setChargeItems(currentItems);
    });
  }

  function saveEditUnit() {
    // check that for a unit that has meters and was added to the lease
    // the initial meter readings were provided for all meter.
    let readyToSendData = true;
    let addedUnitsMeterReadings = [];
    units.forEach((unit) => {
      if (unit.meters) {
        unit.meters.forEach((meter) => {
          if (meter.newMeterReading != null) {
            if (meter.newMeterReading <= meter.lastMeterReading) {
              issueWarnMessage(
                `Initial Meter reading for meter ${meter.name} cannot be less than or equal to the previous reading.`,
              );
              readyToSendData = false;
            } else {
              addedUnitsMeterReadings.push({
                meterId: meter.id,
                newReading: meter.newMeterReading,
              });
            }
          }
        });
      }
    });
    if (readyToSendData) {
      setIsSaving(true);
      saveDeletedUnitsMeterReadings(addedUnitsMeterReadings);
    }
  }

  function saveDeletedUnitsMeterReadings(addedUnitsMeterReadings) {
    let params = deletedUnitMeterReadings;
    let data = { readingDetails: params };
    if (Object.keys(params).length !== 0) {
      saveReadingBulk(data)
        .then((response) => {
          issueResponseMessage(response);
          saveSwap(addedUnitsMeterReadings);
        })
        .catch(() => {
          setIsSaving(false);
        });
    } else {
      saveSwap(addedUnitsMeterReadings);
    }
  }

  function saveSwap(addedUnitsMeterReadings) {
    let sendData = selectedLease;
    sendData.meterReadings = addedUnitsMeterReadings;
    addOrDeleteUnit(sendData)
      .then((response) => {
        issueResponseMessage(response);
        handleUnitSwapClose(true);
      })
      .finally(() => {
        setIsSaving(false);
      });
  }

  function editLastMeterReading(event, unitIndex, meterIndex) {
    let tmp = units;
    if (event.target.value === "") {
      tmp[unitIndex].meters[meterIndex].newMeterReading = null;
    } else {
      let value = tryParseFloat(event.target.value);
      if (isNaN(value)) {
        issueWarnMessage("Meter reading should be a number");
        return;
      } else {
        tmp[unitIndex].meters[meterIndex].newMeterReading = value;
      }
    }
    setUnits(tmp);
    populateUnitSwapItems();
  }

  function dontIssueCharge(deleteUnitIndex) {
    let unitToDelete = units[deleteUnitIndex];
    let meterReadings = deletedUnitMeterReadings;
    if (isArray(unitToDelete.meters) && unitToDelete.meters.length > 0) {
      unitToDelete.meters.forEach((meter) => {
        meterReadings.push({
          meterId: meter.id,
          amount: meter.newMeterReading,
        });
      });
    }
    let tmpUnits = units;
    tmpUnits.splice(deleteUnitIndex, 1);
    let tmpLease = selectedLease;
    tmpLease.leaseChargeItems = tmpLease.leaseChargeItems.filter(
      (charge) => charge.unit.id !== unitToDelete.id,
    );
    let noOfUnits = noOfUnitsBeforeUpdate - 1;
    let thePrevUnits = prevUnits;
    if (!unitToDelete.dateCreated) {
      let myIndex = thePrevUnits.findIndex((e) => e.value === unitToDelete.id);
      thePrevUnits.splice(myIndex, 1);
    }
    setUnits(tmpUnits);
    setSelectedLease(tmpLease);
    setNoOfUnitsBeforeUpdate(noOfUnits);
    setPrevUnits(thePrevUnits);
    setDeletedUnitMeterReadings(meterReadings);
    populateUnitSwapItems();
  }

  function handleUnitDelete(index) {
    let unitToDelete = units[index];
    let unitsCount = [
      ...new Map(
        selectedLease.leaseChargeItems.map((v) => [v.unit.id, v]),
      ).values(),
    ].length;
    let deleteUnit = true;
    if (unitsCount > 1) {
      if (
        !isNullUndefined(unitToDelete.meters) &&
        isArray(unitToDelete.meters) &&
        unitToDelete.meters.length > 0
      ) {
        unitToDelete.meters.forEach((meter) => {
          if (meter.newMeterReading != null) {
            if (meter.newMeterReading <= meter.lastMeterReading) {
              issueWarnMessage(
                `Last Meter reading for meter ${meter.name} cannot be less than or equal to the previous reading.`,
              );
              deleteUnit = false;
            }
          }
        });
      }
      if (deleteUnit) {
        dontIssueCharge(index);
      }
    } else {
      issueWarnMessage(
        `You can't remove all Lease Units. Please add another unit first before deleting this to remain with at least one unit under lease units section.`,
      );
    }
  }

  function populateUnitSwapItems() {
    let rows = "";
    let meterIndex = 0;
    units &&
      units.length > 0 &&
      (rows = units.map(function (unit, i) {
        let meterOptions = unit.meters
          ? unit.meters.map((meter) => {
              return { value: meter.id, label: meter.name };
            })
          : [];
        let placeholder = "No Meter attached to Unit.";
        return (
          <TableRow key={i}>
            <TableCell>{unit.name}</TableCell>
            <TableCell>{unit.tenant}</TableCell>
            <TableCell>{formatCurrency(unit.periodicCharge)}</TableCell>
            <TableCell>
              {meterOptions.length > 0 ? (
                <Select
                  sx={{ width: "90%" }}
                  id={"meter"}
                  placeholder="Select Meter"
                  value={unit.meters[meterIndex].id}
                  onChange={(value) => {
                    let index = meterOptions.findIndex(
                      (e) => e.value === value.value,
                    );
                    meterIndex = index;
                  }}
                >
                  {meterOptions && meterOptions.length > 0 ? (
                    meterOptions.map(function (meter, i) {
                      return (
                        <MenuItem key={i} value={meter.value}>
                          {meter.label}
                        </MenuItem>
                      );
                    }, this)
                  ) : (
                    <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                  )}
                </Select>
              ) : (
                placeholder
              )}
            </TableCell>
            <TableCell>
              {meterOptions.length > 0 ? (
                <TextField
                  sx={{ width: "90%" }}
                  id={"reading" + i}
                  name={"reading" + i}
                  type="number"
                  placeholder={
                    unit.meters[meterIndex].lastMeterReading
                      ? unit.meters[meterIndex].lastMeterReading
                      : "0"
                  }
                  onChange={(event) => {
                    editLastMeterReading(event, i, meterIndex);
                  }}
                  value={
                    isNullUndefined(unit.meters[meterIndex].newMeterReading)
                      ? ""
                      : unit.meters[meterIndex].newMeterReading
                  }
                />
              ) : (
                placeholder
              )}
            </TableCell>
            <TableCell>
              {/* {units.length > 1 && ( */}
              <IconButton
                variant="contained"
                type="submit"
                sx={{ marginLeft: "10px" }}
                onClick={() => handleUnitDelete(i)}
                color="error"
              >
                <Delete sx={{ color: "red" }} />
              </IconButton>
              {/* )} */}
            </TableCell>
          </TableRow>
        );
      }, this));
    setSwapUnitsTableRows(rows);
  }

  function handleLeaseChargeItemAdd() {
    let charge = {
      unit: {
        id: "",
        name: "",
      },
      amount: "",
      chargeCode: { code: "", name: "" },
      taxable: false,
      effectiveDate: new Date(),
      note: "",
    };
    setChargeItems((chargeItems) => [...chargeItems, charge]);
  }

  useEffect(() => {
    populateUnitSwapItems();
  }, [units]);

  useEffect(() => {
    loadModalData();
  }, []);

  return (
    <ModalContainerModule
      size="md"
      accept={
        innerTask === "Lease Units"
          ? saveEditUnit
          : innerTask === "Lease Charges"
            ? saveLeaseCharges
            : () => {}
      }
      cancel={
        innerTask === "Lease Charges"
          ? handleLeaseChargeClose
          : innerTask === "Lease Units"
            ? handleUnitSwapClose
            : () => {}
      }
      openModal={props.task === "Unit Swap"}
      modalTitle={`Add/Swap/Delete Lease Units On Lease ${props.selectedLease && props.selectedLease.billingCode} for ${props.selectedLease && props.selectedLease.tenant && props.selectedLease.tenant.name}`}
      acceptButtonText={
        innerTask === "Lease Units"
          ? "Save Unit Changes"
          : innerTask === "Lease Charges"
            ? "Save Lease Charges"
            : ""
      }
      acceptLoading={isSaving}
    >
      <ResponsiveRow sx={{ padding: "0 10px", width: "100%", height: "auto" }}>
        <Alert severity="info">
          <strong>
            Note: This dialog let's you add, swap or delete units on an ACTIVE
            lease.
          </strong>{" "}
          You swap a unit by deleting one unit and adding another. Please note
          that for units that have a utility meter attached you can add an
          initial reading when adding the unit or add a last reading when
          deleting the unit. To add a unit click on the add button and select
          from the list of available units in the dropdown. Then add the unit's
          lease charges e.g service charge and click on 'Save Lease Charges'. To
          delete a unit click on the red button at the end of the row for the
          particular unit. Click on 'Save Unit Changes' when you are done to
          save the changes made on the lease units.
        </Alert>

        <br />
        {innerTask === "Lease Units" && (
          <>
            <ResponsiveRow sx={{ width: "100%", padding: 0 }}>
              <Typography
                sx={{ marginBottom: "5px", marginTop: "20px" }}
                id="modal-modal-title"
                variant="h5"
                component="h4"
              >
                Lease Units
              </Typography>
              <ResponsiveRow
                sx={{
                  width: { xs: "100%", lg: "90%" },
                  padding: 0,
                  justifyContent: { xs: "center", lg: "flex-end" },
                  flexWrap: "nowrap",
                }}
                item
              >
                <ResponsiveRow
                  sx={{
                    width: { xs: "100%", lg: "90%" },
                    padding: 0,
                  }}
                  item
                >
                  <Grid item sx={{ width: "100%" }}>
                    {showSelectUnit && (
                      <Select
                        sx={{ width: "15%", float: "right" }}
                        id={"unit"}
                        value={selectedUnitId}
                        onChange={(event) => handleSwapUnitChange(event)}
                      >
                        {unitOptions && unitOptions.length > 0 ? (
                          unitOptions.map(function (unit, i) {
                            return (
                              <MenuItem key={i} value={unit.value}>
                                {unit.label}
                              </MenuItem>
                            );
                          }, this)
                        ) : (
                          <MenuItem sx={{ width: "100%" }}>
                            No Results Found
                          </MenuItem>
                        )}
                      </Select>
                    )}
                  </Grid>
                </ResponsiveRow>

                <TopBarContainedBrandButton
                  onClick={() => setShowSelectUnit(true)}
                  sx={{ width: { xs: "100%", lg: "150px" } }}
                >
                  Add Unit{" "}
                </TopBarContainedBrandButton>
              </ResponsiveRow>
            </ResponsiveRow>
            <TableContainer>
              <Table sx={{ minWidth: "100%" }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ width: "15%" }}>Unit</TableCell>
                    <TableCell sx={{ width: "15%" }}>Tenant</TableCell>
                    <TableCell sx={{ width: "20%" }}>Periodic Charge</TableCell>
                    <TableCell sx={{ width: "20%" }}>Meter Name</TableCell>
                    <TableCell
                      sx={{
                        width: "15%",
                      }}
                    >
                      Last Meter Reading
                    </TableCell>

                    <TableCell sx={{ width: "10%" }}>Delete Unit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{swapUnitsTableRows}</TableBody>
              </Table>
            </TableContainer>
          </>
        )}
        {innerTask === "Lease Charges" && (
          <Paper
            variant=""
            sx={{ height: "auto", margin: "auto", padding: "10px" }}
          >
            <Typography
              sx={{ marginBottom: "5px" }}
              id="modal-modal-title"
              variant="h5"
              component="h4"
            >
              <ResponsiveRow container>
                <Grid item sx={{ width: { xs: "100%", lg: "33.3%" } }}>
                  Lease Charges
                </Grid>
              </ResponsiveRow>
              <ResponsiveRow
                item
                sx={{
                  justifyContent: { xs: "center", lg: "flex-end" },
                }}
              >
                <ModalAcceptButton
                  // type="submit"
                  onClick={() => handleLeaseChargeItemAdd()}
                  sx={{ width: { xs: "100%", lg: "200px" } }}
                >
                  Add Row
                </ModalAcceptButton>
              </ResponsiveRow>
            </Typography>
            <LeaseChargeItems
              chargeItems={chargeItems}
              setChargeItems={setChargeItems}
              chargeUnitsOptions={chargeUnitsOptions}
              task={props.task}
              hasRevenueSharing={selectedLease.hasRevenueSharing}
            />
          </Paper>
        )}
        <br />
      </ResponsiveRow>
    </ModalContainerModule>
  );
}
